import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["input"]
  static values = {
    searchUrl: String
  }

  connect() {
    this.initializeSelect2()
  }

  disconnect() {
    // Clean up select2 instance when controller disconnects
    if ($(this.inputTarget).data('select2')) {
      $(this.inputTarget).select2('destroy')
    }
  }

  initializeSelect2() {
    // Get initial value from data attribute (already formatted as "Title (ISBN: xxx)||Title2 (ISBN: yyy)")
    const existingBooks = this.inputTarget.dataset.initialValue || ''
    const booksArray = existingBooks ? existingBooks.split('||').map(b => b.trim()).filter(b => b) : []
    const placeholder = this.inputTarget.dataset.placeholder || ''

    const select2Options = {
      tags: true,
      tokenSeparators: ['+'],
      placeholder: placeholder,
      allowClear: true,
      width: '100%',
      multiple: true,
      containerCssClass: 'select2-auto-height',
      language: {
        errorLoading: () => "Les résultats ne peuvent pas être chargés.",
        inputTooLong: (args) => `Supprimez ${args.input.length - args.maximum} caractère${args.input.length - args.maximum > 1 ? 's' : ''}`,
        inputTooShort: (args) => `Saisissez au moins ${args.minimum - args.input.length} caractère${args.minimum - args.input.length > 1 ? 's' : ''}`,
        loadingMore: () => "Chargement de résultats supplémentaires…",
        maximumSelected: (args) => `Vous pouvez seulement sélectionner ${args.maximum} élément${args.maximum > 1 ? 's' : ''}`,
        noResults: () => "Aucun résultat trouvé",
        searching: () => "Recherche en cours…",
        removeAllItems: () => "Supprimer tous les éléments"
      }
    }

    // Add AJAX if search URL is provided
    if (this.hasSearchUrlValue && this.searchUrlValue) {
      select2Options.ajax = {
        url: this.searchUrlValue,
        dataType: 'json',
        delay: 250,
        data: function (params) {
          return {
            q: params.term
          }
        },
        processResults: function (data) {
          return {
            results: data.results
          }
        },
        cache: true
      }
      select2Options.minimumInputLength = 3
    }

    $(this.inputTarget).select2(select2Options)

    // Manually add the auto-height class to the container for proper expansion
    $(this.inputTarget).data('select2').$container.addClass('select2-auto-height')

    // Set initial values if they exist
    if (booksArray.length > 0) {
      // For tags mode with initial values, we need to create options first
      // The display value comes from the presenter (already formatted)
      // Handle both "display|id" format and plain "Title (ISBN...)" format
      booksArray.forEach(bookDisplay => {
        let optionText, optionValue
        if (bookDisplay.includes('==')) {
          // Format: "display==id"
          const parts = bookDisplay.split('==')
          optionText = parts[0]
          optionValue = parts[1]
        } else {
          // Format: "Title (ISBN...)" - use as both text and value
          optionText = bookDisplay
          optionValue = bookDisplay
        }
        const option = new Option(optionText, optionValue, true, true)
        $(this.inputTarget).append(option)
      })
      $(this.inputTarget).trigger('change')
    }

    // Trigger native change event for auto-save controller
    $(this.inputTarget).on('select2:select select2:unselect select2:clear', (e) => {
      const event = new Event('change', { bubbles: true })
      this.inputTarget.dispatchEvent(event)
    })
  }
}
